/**
 * Darstellung der Mediathek-Sender: Kürzel, Farbe, Logo.
 *
 * Liegt hier statt in einer Route, weil zwei Stellen es brauchen — die
 * Titelseite („Wo du es schauen kannst") und der Mediathek-Bereich. Die Logos
 * sind TMDB-Provider-Bilder, also Assets, die wir ohnehin ausliefern; die
 * Farben sind die Hausfarben der Sender und dienen als Rückfall, wenn kein Logo
 * passt.
 */

export const MEDIATHEK_LOGO = {
	ard: '/avItehPq07h5nKCJgwNTxl6OD0y.jpg',
	zdf: '/ugus0p8BGGhE8sxhwAjJz2o8jyy.jpg',
	arte: '/vPZrjHe7wvALuwJEXT2kwYLi0gV.jpg',
	'3sat': '/mvI5xXSRCBkPlcq83CI21rEMuGk.jpg',
	kika: '/5JkLub6H7HsWyLHbitnuXTzXmlJ.jpg',
}

export interface MediathekChannelStyle {
	label: string
	bg: string
	logo?: string
}

const MEDIATHEK_CHANNEL_STYLE: Record<string, MediathekChannelStyle> = {
	'ARTE.DE': { label: 'ARTE', bg: '#fa4b0a', logo: MEDIATHEK_LOGO.arte },
	'ARTE.FR': { label: 'ARTE', bg: '#fa4b0a', logo: MEDIATHEK_LOGO.arte },
	ARD: { label: 'ARD', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	SWR: { label: 'SWR', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	NDR: { label: 'NDR', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	BR: { label: 'BR', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	WDR: { label: 'WDR', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	MDR: { label: 'MDR', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	HR: { label: 'HR', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	RBB: { label: 'RBB', bg: '#0f2b8e', logo: MEDIATHEK_LOGO.ard },
	PHOENIX: { label: 'phoenix', bg: '#cfa019', logo: MEDIATHEK_LOGO.ard },
	ZDF: { label: 'ZDF', bg: '#fa7d19', logo: MEDIATHEK_LOGO.zdf },
	ZDFneo: { label: 'ZDFneo', bg: '#3b3bb3', logo: MEDIATHEK_LOGO.zdf },
	ZDFinfo: { label: 'ZDFinfo', bg: '#0a5d69', logo: MEDIATHEK_LOGO.zdf },
	'ZDF-tivi': { label: 'ZDFtivi', bg: '#7ab51d', logo: MEDIATHEK_LOGO.zdf },
	'3Sat': { label: '3sat', bg: '#c8003c', logo: MEDIATHEK_LOGO['3sat'] },
	KiKA: { label: 'KiKA', bg: '#78be20', logo: MEDIATHEK_LOGO.kika },
	'Funk.net': { label: 'funk', bg: '#e2b007', logo: MEDIATHEK_LOGO.ard },
}

export function mediathekChannelStyle(channel: string): MediathekChannelStyle {
	return (
		MEDIATHEK_CHANNEL_STYLE[channel] ?? {
			label: channel.replace(/\.DE$/i, ''),
			bg: '#00325f',
		}
	)
}
